StatusMessageCtrl.$inject = ['$scope', 'CurrentCase', 'Errors']

export default function StatusMessageCtrl($scope, CurrentCase, Errors) {

  $scope.errors = Errors;

  $scope.alertType = function (messages) {
    var result = "alert";
    if (messages.message) {
      result += " alert-danger";
    }
    return result;
  };

  $scope.messageText = function (messages) {
    var result = messages.message;
    return result;
  };

  $scope.refreshCase = function () {
    if (CurrentCase.data.id) {
      CurrentCase.api.get()
    }
  };
  $scope.removeNotification = function (msgs, url) {
    delete msgs[url];
  };
};



// WEBPACK FOOTER //
// ./project/directives/status-message/status-message.controller.js